const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaNotificacao: [],
	listaEsporte: [],
	listaProfessor: [],
	listaHoras: [],
	listaQuadra: [],
	listaUsuario: [],
	listaHorariosAgendados: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'AGENDA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'AGENDA_LISTADO':
		console.log(action.payload.data.length);
            return {
				...state,
				lista: action.payload.data
			};

        case 'AGENDA_NOTIFICACAO_LISTADO':
            return {
				...state,
				listaNotificacao: action.payload.data
			};

        case 'AGENDA_AGENDADO_LISTADO':
            return {
				...state,
				listaHorariosAgendados: action.payload.data
			};

		case 'AGENDA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'AGENDA_ESPORTE_SELECT_LISTADO':
            return {
				...state,
				listaEsporte: action.payload.data
			};

        case 'AGENDA_PROFESSOR_SELECT_LISTADO':
            return {
				...state,
				listaProfessor: action.payload.data
			};

        case 'AGENDA_QUADRA_SELECT_LISTADO':
            return {
				...state,
				listaQuadra: action.payload.data
			};

		case 'AGENDA_HORAS_SELECT_LISTADO':
            return {
				...state,
				listaHoras: action.payload
			};

		case 'AGENDA_USUARIO_SELECT_LISTADO':
            return {
				...state,
				listaUsuario: action.payload.data
			};

        default:
            return state;
    }
}
